import React from "react";
import { useSelector } from "react-redux";
import type { IApplicationState } from "../Redux/Reducers";
import { usePageHeaderActionsState } from "./PageHeaderActionsProvider";

type PageHeaderProps = {
	actions?: React.ReactNode;
	sticky?: boolean;
};

/** Sticky page header displaying the current page title and optional action buttons from Redux or props. */
const PageHeader: React.FC<PageHeaderProps> = ({ actions, sticky = true }) => {
	const header = useSelector((state: IApplicationState) => state.pageHeader);
	const contextualActions = usePageHeaderActionsState();
	const renderedActions = (
		<div className="flex flex-wrap gap-2 ml-auto justify-end">
			{actions ?? contextualActions}
		</div>
	);

	const containerClasses = sticky
		? "sticky top-0 z-30 border-b border-slate-200 bg-white/95 px-4 sm:px-6 py-4 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-white/80"
		: "border-b border-slate-200 bg-white px-4 sm:px-6 py-4";

	if (!header.title && !renderedActions) {
		return null;
	}

	return (
		<div className={containerClasses}>
			<div className="flex flex-wrap items-center justify-between gap-4">
				<div>
					{header.title && <p className="text-lg font-semibold text-slate-900">{header.title}</p>}
				</div>
				{renderedActions}
			</div>
		</div>
	);
};

export default PageHeader;
